import { useEffect, useState } from "react";
import { Check } from "lucide-react";

// Aviso discreto de guardado automático. Sobrio, sin ícono por pregunta:
// aparece brevemente arriba del formulario cada vez que se confirma un guardado
// exitoso en el servidor, y se desvanece solo. Presentación pura.
export const AutosaveBanner = ({ trigger }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!trigger) return;
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 2200);
    return () => clearTimeout(t);
  }, [trigger]);

  return (
    <div
      data-testid="diagnostic-autosave-banner"
      aria-live="polite"
      className={`inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-[11px] font-semibold text-slate-500 shadow-sm transition-opacity duration-300 ${visible ? "opacity-100" : "opacity-0"}`}
    >
      <Check className="w-3 h-3 text-emerald-500" /> Cambios guardados
    </div>
  );
};
